import { DatePicker } from "antd";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import locale from "antd/locale/nl_NL";

const { RangePicker } = DatePicker;

export const AnalyticsDateRangePicker = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const from = searchParams.get("from");
  const to = searchParams.get("to");

  // Dayjs is required for antd DatePicker to work correctly
  const fromDate = dayjs(from).isValid() ? dayjs(from) : null;
  const toDate = dayjs(to).isValid() ? dayjs(to) : null;

  const handleDateChange = (
    dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null,
  ) => {
    if (dates && dates[0] && dates[1]) {
      setSearchParams({
        from: dates[0].format("YYYY-MM-DD"),
        to: dates[1].format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <RangePicker
      value={[fromDate, toDate]}
      onChange={handleDateChange}
      format="DD-MM-YYYY"
      allowClear={false}
      locale={locale.DatePicker}
    />
  );
};
